// extracted by mini-css-extract-plugin
var _1 = "AttachmentContainer-module__animatedBackground--RQRMT";
var _2 = "AttachmentContainer-module__attachmentArea--o2APb";
var _3 = "AttachmentContainer-module__attachmentAreaContainer--eDHXN";
var _4 = "AttachmentContainer-module__attachmentGrid--fHOK2";
var _5 = "70px";
var _6 = "AttachmentContainer-module__container--KxToN";
var _7 = "AttachmentContainer-module__hasOpenMenu--UazUp";
var _8 = "AttachmentContainer-module__header--BIjB8";
var _9 = "AttachmentContainer-module__isExpanded--l7H19";
var _a = "AttachmentContainer-module__meta--nPzJH";
var _b = "AttachmentContainer-module__narrow--PH7p6";
var _c = "AttachmentContainer-module__placeholder--AlBNV";
export { _1 as "animatedBackground", _2 as "attachmentArea", _3 as "attachmentAreaContainer", _4 as "attachmentGrid", _5 as "collapsedHeight", _6 as "container", _7 as "hasOpenMenu", _8 as "header", _9 as "isExpanded", _a as "meta", _b as "narrow", _c as "placeholder" }
